// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ba5852a3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/LabTestHistoryGraph/index.styl
// module id = 5058
// module chunks = 39